import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Event from "./components/Events2/Event.js";
import Navbar from "./components/Navbar/Navbar.js";
import Home from "./components/Main/Home.js";
import Footer from "./components/Footer/Footer.js";
import ReactimageGallery from "./components/Gallery/ReactimageGallery.js";
import "./index.css";
import "./App.css";
import SignUp from "./components/Login/SignUp/SignUp.js";
import SignIn from "./components/Login/SignIn/SignIn.js";
import ForgotPw from "./components/Login/ForgotPw.js";
import AuthProvider from "./components/Context/authContext.js";
import Error from "./components/Error/Error.js";

const ScrollToTop = (props) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return <>{props.children}</>;
};
const App = () => {
  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <ScrollToTop>
            <Routes>
              <Route exact index path="/" element={<Home />} />
              <Route path="/events" element={<Event />} />
              <Route exact path="/events/:eventName" element={<Event />} />
              <Route exact path="/gallery" element={<ReactimageGallery />} />
              <Route exact path="/login" element={<SignIn />} />
              <Route exact path="/signup" element={<SignUp />} />
              <Route exact path="/forgotpw" element={<ForgotPw />} />
              <Route path="*" element={<Error/>} />
            </Routes>
            <Footer />
          </ScrollToTop>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
};

export default App;